var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"world-terrain-map-page"},[_c('iframe',{staticClass:"terrain-map-frame",attrs:{"title":"世界山川地形图","src":"/static/maps/world-terrain-map.html?v=20260712-2","loading":"eager"}})])
}]

export { render, staticRenderFns }